import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io vs Hotelogix',
  heroSubtitle: 'Une comparaison compl\u00e8te de deux plateformes de gestion h\u00f4teli\u00e8re de premier plan. D\u00e9couvrez comment HotelStack.io offre plus de fonctionnalit\u00e9s, une architecture moderne et un meilleur rapport qualit\u00e9-prix que Hotelogix.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules int\u00e9gr\u00e9s', competitor: '15 modules' },
    { label: 'Architecture', hotelstack: 'SaaS cloud natif', competitor: 'Cloud h\u00e9rit\u00e9' },
    { label: 'Port\u00e9e mondiale', hotelstack: 'Plus de 40 pays', competitor: 'Principalement Asie' },
    { label: 'Gestionnaire de canaux', hotelstack: 'Int\u00e9gr\u00e9 (100+ OTA)', competitor: 'Module compl\u00e9mentaire requis' },
    { label: 'Moteur de r\u00e9servation', hotelstack: 'BookMyRoom.io (gratuit)', competitor: 'Widget basique' },
    { label: 'Support', hotelstack: 'D\u00e9di\u00e9 24h/24 7j/7', competitor: 'E-mail + Chat' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Enregistrement par glisser-d\u00e9poser', hotelstack: true, competitor: false },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Gestion du folio client', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: false },
        { name: 'Fen\u00eatre de r\u00e9servation sans rendez-vous', hotelstack: true, competitor: 'Limit\u00e9' },
      ],
    },
    {
      category: 'Gestion des revenus',
      features: [
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: false },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: false },
        { name: 'Analyses RevPAR', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Gestion des clients',
      features: [
        { name: 'Profils clients 360 degr\u00e9s', hotelstack: true, competitor: 'Basique' },
        { name: 'Gestion du programme de fid\u00e9lit\u00e9', hotelstack: true, competitor: false },
        { name: 'Automatisation de la communication client', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Analyses des d\u00e9penses clients', hotelstack: true, competitor: false },
        { name: 'T\u00e9l\u00e9chargement d\'identit\u00e9 et capture photo', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Restauration et point de vente',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Plan de salle du restaurant', hotelstack: true, competitor: false },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Rapports et analyses',
      features: [
        { name: 'Rapport flash', hotelstack: true, competitor: true },
        { name: 'Compte de r\u00e9sultat', hotelstack: true, competitor: false },
        { name: 'Rapport de rythme', hotelstack: true, competitor: false },
        { name: 'Rapports de conformit\u00e9 fiscale', hotelstack: true, competitor: 'Basique' },
        { name: 'G\u00e9n\u00e9rateur de rapports personnalis\u00e9s', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-\u00e9tablissements',
      features: [
        { name: 'Tableau de bord de la cha\u00eene', hotelstack: true, competitor: true },
        { name: 'Analyses inter-\u00e9tablissements', hotelstack: true, competitor: false },
        { name: 'Gestion centralis\u00e9e des tarifs', hotelstack: true, competitor: false },
        { name: 'Param\u00e8tres de marque', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: 'Les 36 modules inclus. Aucune restriction de fonctionnalit\u00e9s. Int\u00e9gration et migration de donn\u00e9es gratuites. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB.',
    competitorNote: 'Plan de base avec des modules limit\u00e9s. Le gestionnaire de canaux et les fonctionnalit\u00e9s avanc\u00e9es co\u00fbtent en suppl\u00e9ment.',
  },
  advantages: [
    'Plus du double des modules (36 contre 15) sans frais suppl\u00e9mentaires pour les fonctionnalit\u00e9s de base',
    'Architecture cloud native moderne construite en 2024 avec synchronisation en temps r\u00e9el sur tous les appareils',
    'Support multidevise avec tarification r\u00e9gionale en 6 devises et outils de conformit\u00e9 pour plus de 40 pays',
    'Moteur de r\u00e9servation int\u00e9gr\u00e9 via BookMyRoom.io \u2014 r\u00e9servations directes sans commission incluses',
    'Gestion avanc\u00e9e des revenus avec tarification dynamique, pr\u00e9vision de la demande et simulateurs hypoth\u00e9tiques',
    'Module complet de restauration et POS avec gestion des tables, affichage cuisine et service en chambre',
    'Prix de d\u00e9part inf\u00e9rieur avec plus de fonctionnalit\u00e9s incluses dans le plan de base',
    'Migration de donn\u00e9es gratuite depuis Hotelogix avec support d\'int\u00e9gration d\u00e9di\u00e9',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'HotelStack.io est le choix le plus solide pour les h\u00f4tels recherchant une plateforme moderne et tout-en-un. Avec 36 modules, la gestion int\u00e9gr\u00e9e des revenus, les capacit\u00e9s de restauration et des tarifs inf\u00e9rieurs, il offre une valeur nettement sup\u00e9rieure \u00e0 Hotelogix. Hotelogix peut convenir aux h\u00f4tels \u00e0 budget limit\u00e9 n\u00e9cessitant uniquement les fonctionnalit\u00e9s PMS de base.',
    bestFor: [
      'H\u00f4tels souhaitant une plateforme moderne tout-en-un sans frais suppl\u00e9mentaires',
      '\u00c9tablissements n\u00e9cessitant une gestion avanc\u00e9e des revenus et une tarification dynamique',
      'H\u00f4tels ayant besoin de restauration, POS et service en chambre',
      '\u00c9tablissements n\u00e9cessitant la conformit\u00e9 r\u00e9gionale et la facturation multidevise',
      'Cha\u00eenes multi-\u00e9tablissements n\u00e9cessitant des analyses centralis\u00e9es et une gestion tarifaire unifi\u00e9e',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de Hotelogix vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe g\u00e8re la migration compl\u00e8te des donn\u00e9es depuis Hotelogix, y compris les profils clients, l\'historique des r\u00e9servations, les plans tarifaires et les configurations de chambres. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans aucune interruption.' },
    { question: 'HotelStack.io poss\u00e8de-t-il toutes les fonctionnalit\u00e9s de Hotelogix ?', answer: 'HotelStack.io inclut chaque fonctionnalit\u00e9 propos\u00e9e par Hotelogix plus 17 modules suppl\u00e9mentaires comprenant la gestion des revenus, la restauration/POS, les programmes de fid\u00e9lit\u00e9, les outils de conformit\u00e9 et les analyses avanc\u00e9es que Hotelogix ne propose pas.' },
    { question: 'Comment les tarifs se comparent-ils entre HotelStack.io et Hotelogix ?', answer: 'HotelStack.io d\u00e9marre \u00e0 49 $/mois avec les 36 modules inclus. Tarification r\u00e9gionale disponible en EUR, GBP, AED, INR et THB. Hotelogix d\u00e9marre \u00e0 environ 60 $+/mois pour le plan de base, avec des frais suppl\u00e9mentaires pour le gestionnaire de canaux et d\'autres fonctionnalit\u00e9s.' },
    { question: 'HotelStack.io convient-il aux petits h\u00f4tels utilisant actuellement Hotelogix ?', answer: 'Absolument. Notre plan Starter est con\u00e7u pour les \u00e9tablissements jusqu\'\u00e0 50 chambres avec toutes les fonctionnalit\u00e9s d\u00e9bloqu\u00e9es. De nombreux petits h\u00f4tels quittent Hotelogix pour les modules suppl\u00e9mentaires et le prix inf\u00e9rieur.' },
  ],
};

const CLOUDBEDS_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io vs Cloudbeds',
  heroSubtitle: 'Toutes deux sont des plateformes cloud natives. HotelStack.io offre plus de modules, des tarifs inf\u00e9rieurs et des capacit\u00e9s compl\u00e8tes de restauration/POS que Cloudbeds ne propose pas \u2014 le tout avec une tarification r\u00e9gionale multidevise.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules', competitor: 'Plus de 20 modules' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 100 $+/mois' },
    { label: 'Tarification r\u00e9gionale', hotelstack: '6 devises', competitor: 'USD uniquement' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Moteur de r\u00e9servation', hotelstack: 'BookMyRoom.io (gratuit)', competitor: 'Widget basique' },
    { label: 'Int\u00e9gration', hotelstack: 'Gratuite + d\u00e9di\u00e9e', competitor: 'En libre-service' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Conformit\u00e9 r\u00e9gionale',
      features: [
        { name: 'Facturation multidevise', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Automatisation fiscale r\u00e9gionale', hotelstack: true, competitor: false },
        { name: 'Conformit\u00e9 d\'enregistrement des clients', hotelstack: true, competitor: false },
        { name: 'Protection des donn\u00e9es RGPD', hotelstack: true, competitor: true },
        { name: 'Passerelles de paiement r\u00e9gionales', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Facturation localis\u00e9e', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Gestion des revenus',
      features: [
        { name: 'Tarification dynamique', hotelstack: true, competitor: true },
        { name: 'Analyses des revenus', hotelstack: true, competitor: true },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'Simulateur hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Restauration et op\u00e9rations',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Tableau de m\u00e9nage', hotelstack: true, competitor: true },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Conformit\u00e9 et rapports',
      features: [
        { name: 'Rapports fiscaux r\u00e9gionaux', hotelstack: true, competitor: false },
        { name: 'Piste d\'audit', hotelstack: true, competitor: true },
        { name: 'Compte de r\u00e9sultat', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'G\u00e9n\u00e9rateur de rapports personnalis\u00e9s', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'Les 36 modules inclus. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration gratuites.',
    competitorNote: 'Tarification en USD uniquement (100 $+/mois). Frais suppl\u00e9mentaires pour les fonctionnalit\u00e9s premium et les int\u00e9grations.',
  },
  advantages: [
    'Les 36 modules inclus \u00e0 environ la moiti\u00e9 du co\u00fbt \u2014 sans frais suppl\u00e9mentaires pour les fonctionnalit\u00e9s de base',
    'Tarification r\u00e9gionale en 6 devises \u2014 pas de surprises de taux de change pour les \u00e9tablissements internationaux',
    'Module complet de restauration avec terminal POS, service en chambre et gestion de cuisine',
    'Outils de conformit\u00e9 r\u00e9gionale pour l\'automatisation fiscale, l\'enregistrement des clients et le RGPD',
    'Support multi-passerelles de paiement via PaymentHooks.com (Stripe, PayPal, 50+ passerelles) pour les m\u00e9thodes mondiales et locales',
    'Module de gestion du personnel avec paie, pr\u00e9sence et planification des \u00e9quipes',
    'Gestion de la maintenance et des ordres de travail avec suivi des actifs',
    'Int\u00e9gration et migration de donn\u00e9es gratuites avec \u00e9quipe de support d\u00e9di\u00e9e',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'HotelStack.io offre plus de modules, une meilleure valeur et des outils op\u00e9rationnels complets \u00e0 environ la moiti\u00e9 du prix de Cloudbeds. Bien que Cloudbeds soit une plateforme solide pour le PMS de base et la gestion des canaux, HotelStack.io ajoute la restauration/POS, la gestion du personnel, la maintenance et des outils de revenus avanc\u00e9s \u2014 le tout inclus dans le prix de base.',
    bestFor: [
      'H\u00f4tels souhaitant une plateforme compl\u00e8te tout-en-un \u00e0 un prix inf\u00e9rieur',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et gestion du personnel dans un seul syst\u00e8me',
      'H\u00f4tels souhaitant la conformit\u00e9 r\u00e9gionale et la facturation multidevise',
      '\u00c9tablissements pr\u00e9f\u00e9rant une int\u00e9gration d\u00e9di\u00e9e plut\u00f4t qu\'une configuration en libre-service',
      'Cha\u00eenes multi-\u00e9tablissements n\u00e9cessitant des analyses centralis\u00e9es et une gestion tarifaire unifi\u00e9e',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de Cloudbeds vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe d\'int\u00e9gration g\u00e8re la migration compl\u00e8te des donn\u00e9es depuis Cloudbeds, y compris les profils clients, l\'historique des r\u00e9servations et les plans tarifaires. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures.' },
    { question: 'HotelStack.io prend-il en charge les m\u00eames canaux OTA que Cloudbeds ?', answer: 'Oui. HotelStack.io se connecte \u00e0 plus de 100 OTA, notamment Booking.com, Expedia, Airbnb, Agoda et les plateformes r\u00e9gionales. La connectivit\u00e9 GDS via Amadeus et Sabre est \u00e9galement prise en charge.' },
    { question: 'Pourquoi HotelStack.io est-il plus abordable que Cloudbeds ?', answer: 'HotelStack.io inclut les 36 modules dans chaque plan sans frais suppl\u00e9mentaires. La tarification r\u00e9gionale en 6 devises r\u00e9duit davantage les co\u00fbts. Cloudbeds facture un suppl\u00e9ment pour les fonctionnalit\u00e9s premium et propose uniquement une tarification en USD.' },
    { question: 'HotelStack.io fonctionne-t-il pour les \u00e9tablissements internationaux ?', answer: 'Absolument. HotelStack.io prend en charge la facturation multidevise, la conformit\u00e9 fiscale r\u00e9gionale et les passerelles de paiement internationales. Des h\u00f4tels dans plus de 40 pays utilisent HotelStack.io pour g\u00e9rer leurs op\u00e9rations.' },
  ],
};

const MEWS_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io vs Mews',
  heroSubtitle: 'Mews cible les h\u00f4tels d\'entreprise avec des tarifs premium et une impl\u00e9mentation payante. HotelStack.io offre la m\u00eame exp\u00e9rience moderne avec plus de modules \u00e0 une fraction du co\u00fbt \u2014 int\u00e9gration gratuite incluse.',
  overviewComparison: [
    { label: 'Segment h\u00f4telier', hotelstack: 'PME \u00e0 entreprise', competitor: 'Entreprise uniquement' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '200 $+/mois' },
    { label: 'Modules totaux', hotelstack: '36 int\u00e9gr\u00e9s', competitor: '15+ modules de base' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Via int\u00e9gration' },
    { label: 'Qualit\u00e9 UI/UX', hotelstack: 'Design luxe sombre moderne', competitor: 'Design minimaliste moderne' },
    { label: 'Int\u00e9gration', hotelstack: 'Gratuite + d\u00e9di\u00e9e', competitor: 'Impl\u00e9mentation payante' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Architecture cloud native', hotelstack: true, competitor: true },
        { name: 'UI/UX moderne', hotelstack: true, competitor: true },
        { name: 'Synchronisation en temps r\u00e9el', hotelstack: true, competitor: true },
        { name: 'Acc\u00e8s multi-appareils', hotelstack: true, competitor: true },
        { name: 'Automatisation de l\'audit de nuit', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Conformit\u00e9 r\u00e9gionale',
      features: [
        { name: 'Facturation multidevise', hotelstack: true, competitor: true },
        { name: 'Automatisation fiscale r\u00e9gionale', hotelstack: true, competitor: 'UE uniquement' },
        { name: 'Conformit\u00e9 d\'enregistrement des clients', hotelstack: true, competitor: 'UE uniquement' },
        { name: 'Protection des donn\u00e9es RGPD', hotelstack: true, competitor: true },
        { name: 'Passerelles de paiement r\u00e9gionales', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Tarification r\u00e9gionale (6 devises)', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Revenus et distribution',
      features: [
        { name: 'Gestionnaire de canaux', hotelstack: true, competitor: true },
        { name: 'Tarification dynamique', hotelstack: true, competitor: true },
        { name: 'Moteur de r\u00e9servation', hotelstack: true, competitor: true },
        { name: 'Analyses des revenus', hotelstack: true, competitor: true },
        { name: 'Simulateur hypoth\u00e9tique', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Op\u00e9rations',
      features: [
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: true },
        { name: 'Module POS / Restauration', hotelstack: true, competitor: 'Via int\u00e9gration' },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
        { name: 'Maintenance / Ordres de travail', hotelstack: true, competitor: false },
        { name: 'Communication avec les clients', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Tarification et support',
      features: [
        { name: 'Int\u00e9gration gratuite', hotelstack: true, competitor: false },
        { name: 'Migration de donn\u00e9es gratuite', hotelstack: true, competitor: false },
        { name: 'Support 24h/24 7j/7', hotelstack: true, competitor: 'Heures ouvrables' },
        { name: 'Pas de frais d\'impl\u00e9mentation', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: true },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: 'Via int\u00e9gration' },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: 'Via int\u00e9gration' },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: 'Les 36 modules inclus. Int\u00e9gration et migration gratuites. Tarification r\u00e9gionale en 6 devises.',
    competitorNote: 'Tarification entreprise (200 $+/mois). Impl\u00e9mentation et int\u00e9gration payantes. Support premium en suppl\u00e9ment.',
  },
  advantages: [
    'Prix de d\u00e9part inf\u00e9rieur d\'environ 75 % avec plus de modules inclus dans chaque plan',
    'Int\u00e9gration et migration de donn\u00e9es gratuites contre impl\u00e9mentation payante chez Mews',
    'Restauration et POS int\u00e9gr\u00e9s contre int\u00e9gration tierce requise avec Mews',
    'Tarification r\u00e9gionale en 6 devises \u2014 les h\u00f4tels paient dans leur devise locale',
    'Gestion du personnel, paie et planification des \u00e9quipes incluses',
    'Gestion de la maintenance et des ordres de travail int\u00e9gr\u00e9e \u00e0 la plateforme',
    'Support d\u00e9di\u00e9 24h/24 7j/7 contre support aux heures ouvrables chez Mews',
    'Accessible aux PME, pas seulement aux entreprises \u2014 tous les plans incluent tous les modules',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'Mews est une excellente plateforme pour les h\u00f4tels d\'entreprise pr\u00eats \u00e0 payer des tarifs premium. HotelStack.io \u00e9gale Mews en UX moderne et architecture cloud tout en ajoutant la restauration/POS, la gestion du personnel et les modules de maintenance \u2014 le tout \u00e0 environ un quart du prix avec une int\u00e9gration gratuite.',
    bestFor: [
      'H\u00f4tels souhaitant la qualit\u00e9 UX de Mews \u00e0 un prix plus accessible',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et outils op\u00e9rationnels int\u00e9gr\u00e9s',
      'H\u00f4tels souhaitant une int\u00e9gration gratuite sans frais d\'impl\u00e9mentation',
      'PME et \u00e9tablissements de taille moyenne exclus des plans entreprise de Mews',
      'Cha\u00eenes multi-\u00e9tablissements n\u00e9cessitant une gestion centralis\u00e9e avec conformit\u00e9 r\u00e9gionale',
    ],
  },
  faqItems: [
    { question: 'Comment HotelStack.io se compare-t-il \u00e0 Mews en termes de qualit\u00e9 d\'interface ?', answer: 'Les deux plateformes offrent des interfaces modernes et intuitives. HotelStack.io pr\u00e9sente un th\u00e8me luxe sombre con\u00e7u sp\u00e9cifiquement pour l\'industrie h\u00f4teli\u00e8re, avec 36 modules enti\u00e8rement int\u00e9gr\u00e9s accessibles depuis un seul tableau de bord. Mews a un design minimaliste \u00e9pur\u00e9 ax\u00e9 sur les flux de travail europ\u00e9ens.' },
    { question: 'Mews inclut-il des capacit\u00e9s de restauration et POS ?', answer: 'Mews n\u00e9cessite des int\u00e9grations tierces pour la restauration et le POS. HotelStack.io inclut un terminal POS complet, un module de service en chambre, un syst\u00e8me d\'affichage cuisine et la gestion de restaurant en fonctionnalit\u00e9s standard dans chaque plan.' },
    { question: 'Puis-je obtenir la m\u00eame exp\u00e9rience moderne que Mews \u00e0 un prix inf\u00e9rieur ?', answer: 'Oui. HotelStack.io offre une exp\u00e9rience cloud native moderne avec synchronisation en temps r\u00e9el, une belle interface et 36 modules \u00e0 49 $/mois contre 200 $+/mois pour Mews. De plus, l\'int\u00e9gration et la migration sont gratuites.' },
    { question: 'HotelStack.io propose-t-il des int\u00e9grations API comme Mews ?', answer: 'Oui. HotelStack.io fournit une place de march\u00e9 d\'int\u00e9grations avec des API pour les passerelles de paiement, les OTA, les logiciels de comptabilit\u00e9 et les services tiers. Notre architecture orient\u00e9e API prend en charge les int\u00e9grations personnalis\u00e9es pour les besoins d\'entreprise.' },
  ],
};

export const COMPARISON_FR: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_FR,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_FR,
  'hotelstack-vs-mews': MEWS_FR,
};
